import axios, { AxiosRequestConfig } from 'axios';
import { Executable } from './executable';

export class BambuUserClient {
  private _token: string;

  private _tenantId: string;

  private _domain: string;

  private _rootPath: string;

  constructor(
    tenantId: string,
    token: string,
    domain: string = 'nft.bambumeta.software',
    root: string = 'nft'
  ) {
    this._tenantId = tenantId;
    this._token = token;
    this._domain = domain;
    this._rootPath = root;
  }

  public async execute<T extends Executable<any>>(
    executeable: T
  ): Promise<T extends Executable<infer U> ? U : never> {
    const input: AxiosRequestConfig = {
      method: executeable.getMethod(),
      url: `https://${this._domain}/${
        executeable.getRootPath() || this._rootPath
      }/${executeable.getURLPath(this._tenantId)}`,
      headers: {
        Authorization: `Bearer ${await this._token}`,
      },
    };
    const _body = executeable.getBody();
    if (_body) {
      input.data = _body;
    }
    return axios.request(input).then((response) => {
      return executeable.getResponse(response.data);
    });
  }
}
